import { useState } from 'hooks'
import { getDatagridIconsEditSelectors } from 'selectors'

type State = {
	container?: HTMLElement
	iconsSelect?: HTMLElement
}

export const DatagridIconsEdit = () => {
	const { state, setState } = useState<State>()

	const initEditIcons = () => {
		const { container, iconsSelect } = state

		if (!container) {
			return
		}
		if (!iconsSelect) {
			return
		}

		const parent = iconsSelect.parentElement
		if (!parent) {
			return
		}

		const parentInput = parent.querySelector('input')
		if (!parentInput) {
			return
		}

		const selectId = parentInput.getAttribute('data-target')
		if (!selectId) {
			return
		}

		const select = document.getElementById(selectId)
		if (!select) {
			return
		}

		const options = select.querySelectorAll('.select-dropdown li')
		if (!options) {
			return
		}

		for (let i = 0; i <= options.length; i++) {
			if (options[i]) {
				const iconName = options[i].querySelectorAll('span')[0].innerHTML
				options[i].innerHTML = `<span class="icon-preview align-right"><i class="fal ${iconName}"></i></span>`
			}
		}
	}

	const init = () => {
		setState({ ...getDatagridIconsEditSelectors() })

		initEditIcons()
	}

	return {
		init,
	}
}
